


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { findContrastColor } from '@/utils'
import bus, { SYNC } from '@/utils/bus-event'
import accountService from '@/services/AccountService'
import IAccount from '@/models/IAccount'
import IColor from '@/models/IColor'
import IUser from '@/models/IUser'
import FabButton from '@/components/FabButton.vue'
import AccountCard from '@/components/AccountCard.vue'

@Component({
  components: {
    'fab-button': FabButton,
    'account-card': AccountCard
  }
})
export default class AccountList extends Vue {
  @Getter
  public user!: IUser | null
  @Prop({ type: Boolean, default: false })
  public archived!: boolean
  public accounts: IAccount[] = []
  public fetched: boolean = false
  public textColor: string = ''
  public async created(): Promise<void> {
    this.getData()
    bus.$on(SYNC, this.getData)
  }

  public beforeDestroy() {
    bus.$off(SYNC, this.getData)
  }

  public async getData(): Promise<void> {
    this.accounts = await accountService.getAll(this.archived)
    this.fetched = true
  }
}
